/**
 * Home Product Cards - Interactive functionality
 * Handles: Add to Cart (Shopify /cart/add.js), Wishlist (localStorage), Quick View
 * Uses capturing phase to fire BEFORE PrestaShop jQuery handlers.
 */
(function() {
  'use strict';

  // ========================
  // ADD TO CART
  // ========================
  document.addEventListener('click', function(e) {
    var button = e.target.closest('.home-add-to-cart');
    if (!button) return;

    var form = button.closest('form');
    if (!form) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    if (button.disabled) return;
    button.disabled = true;
    button.classList.add('loading');

    var variantId = form.querySelector('input[name="id"]').value;
    var quantity = form.querySelector('input[name="quantity"]').value || '1';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: parseInt(variantId),
        quantity: parseInt(quantity)
      })
    })
    .then(function(response) {
      if (!response.ok) throw new Error('Cart add failed');
      return response.json();
    })
    .then(function(item) {
      button.disabled = false;
      button.classList.remove('loading');

      // Show success feedback
      var content = button.querySelector('.leo-bt-cart-content');
      if (content) {
        var originalHTML = content.innerHTML;
        content.innerHTML = '<span class="name-btn-product" style="color:#61ce70;">Added!</span>';
        setTimeout(function() { content.innerHTML = originalHTML; }, 1500);
      }

      // Update cart count badge
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          // Update all cart count elements
          document.querySelectorAll('.cart-products-count, .cart-count, [data-cart-count], .header .cart_block_list .products .total_price, .cart-block .cart-products-count').forEach(function(el) {
            el.textContent = cart.item_count;
          });

          // Try to trigger cart drawer / fly cart effect
          if (typeof prestashop !== 'undefined' && prestashop.emit) {
            prestashop.emit('updateCart', { resp: { cart: cart } });
          }
        })
        .catch(function() {});
    })
    .catch(function(err) {
      button.disabled = false;
      button.classList.remove('loading');
      console.error('Add to cart error:', err);
    });
  }, true);

  // ========================
  // WISHLIST (localStorage)
  // ========================
  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem('miotots_wishlist')) || [];
    } catch(e) {
      return [];
    }
  }

  function saveWishlist(list) {
    localStorage.setItem('miotots_wishlist', JSON.stringify(list));
  }

  function toggleWishlist(productId) {
    var list = getWishlist();
    var idx = list.indexOf(productId);
    if (idx > -1) {
      list.splice(idx, 1);
    } else {
      list.push(productId);
    }
    saveWishlist(list);
    return idx === -1;
  }

  function isWishlisted(productId) {
    return getWishlist().indexOf(productId) > -1;
  }

  function updateWishlistVisual(btn, added) {
    var defaultIcon = btn.querySelector('.wishlist-icon-default');
    var activeIcon = btn.querySelector('.wishlist-icon-active');
    var addText = btn.querySelector('.text-add');
    var removeText = btn.querySelector('.text-remove');

    if (added) {
      if (defaultIcon) defaultIcon.style.display = 'none';
      if (activeIcon) activeIcon.style.display = 'inline';
      if (addText) addText.style.display = 'none';
      if (removeText) { removeText.style.display = 'inline'; }
      btn.classList.add('added');
    } else {
      if (defaultIcon) defaultIcon.style.display = 'inline';
      if (activeIcon) activeIcon.style.display = 'none';
      if (addText) addText.style.display = 'inline';
      if (removeText) removeText.style.display = 'none';
      btn.classList.remove('added');
    }
  }

  function updateWishlistStates() {
    document.querySelectorAll('.home-wishlist-btn[data-product-id]').forEach(function(btn) {
      var id = parseInt(btn.getAttribute('data-product-id'));
      updateWishlistVisual(btn, isWishlisted(id));
    });
  }

  // Use CAPTURING phase (true) so this fires BEFORE jQuery's bubbling handlers
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.home-wishlist-btn');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    var productId = parseInt(btn.getAttribute('data-product-id'));
    if (!productId) return;

    var added = toggleWishlist(productId);
    updateWishlistVisual(btn, added);

    // Brief visual feedback
    btn.style.transform = 'scale(1.3)';
    setTimeout(function() { btn.style.transform = ''; }, 200);
  }, true);

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateWishlistStates);
  } else {
    updateWishlistStates();
  }

  // Re-check wishlist states when tab content changes
  var observer = new MutationObserver(function() {
    updateWishlistStates();
  });
  observer.observe(document.body, { childList: true, subtree: true });

})();
